import AuthenticationRoutes from 'authentication/config/routes/routes';
import AuthRouting from 'authentication/config/routes/routes.authentication';
import CashOutRoutes from 'cashout/config/routes/routes';
import CashoutRouting from 'cashout/config/routes/routes.cashout';
import DepositRoutes from 'deposit/config/routes/routes';
import DepositRouting from 'deposit/config/routes/routes.deposit';
import MicroMerchantRoutes from 'micro-merchant/config/routes/routes';
import PaymentLinkRoutes from 'payment-link/config/routes/routes';
import PaymentLinkRouting from 'payment-link/config/routes/routes.payment-link';
import WalletTransferRoutes from 'wallet-transfer/config/routes/routes';
import WalletTransferRouting from 'wallet-transfer/config/routes/routes.wallet-transfer';

import { RouteType } from 'common/config/routes/routes.type';

export interface AppTypeConfig {
  appType: AppType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  LayoutToUse: React.FC<any>;
  routes: RouteType[];
}

export enum AppType {
  CASHOUT = 'CASHOUT',
  DEPOSIT = 'DEPOSIT',
  WALLET_TRANSFER = 'WALLET_TRANSFER',
  PAYMENT_LINK = 'PAYMENT_LINK',
  MICRO_MERCHANT = 'MICRO_MERCHANT',
  AUTH = 'AUTHENTICATION',
  INVALID = 'INVALID',
}

export function getAppTypeConfig(): AppTypeConfig {
  const appModuleType = getAppModuleType();

  const appTypeConfig: { [key in AppType]: AppTypeConfig } = {
    [AppType.DEPOSIT]: {
      appType: appModuleType,
      LayoutToUse: DepositRouting,
      routes: DepositRoutes,
    },
    [AppType.CASHOUT]: {
      appType: appModuleType,
      LayoutToUse: CashoutRouting,
      routes: CashOutRoutes,
    },
    [AppType.PAYMENT_LINK]: {
      appType: appModuleType,
      LayoutToUse: PaymentLinkRouting,
      routes: PaymentLinkRoutes,
    },
    [AppType.WALLET_TRANSFER]: {
      appType: appModuleType,
      LayoutToUse: WalletTransferRouting,
      routes: WalletTransferRoutes,
    },
    [AppType.MICRO_MERCHANT]: {
      appType: appModuleType,
      LayoutToUse: DepositRouting,
      routes: MicroMerchantRoutes,
    },
    [AppType.AUTH]: {
      appType: appModuleType,
      LayoutToUse: AuthRouting,
      routes: AuthenticationRoutes,
    },
    [AppType.INVALID]: {
      appType: appModuleType,
      LayoutToUse: DepositRouting,
      routes: DepositRoutes,
    },
  };

  return appTypeConfig[appModuleType];
}

export function getAppModuleType() {
  const path = window.location.pathname.split('/')[1];

  const pathToAppModuleType: { [key: string]: AppType } = {
    deposit: AppType.DEPOSIT,
    cashout: AppType.CASHOUT,
    payment: AppType.PAYMENT_LINK,
    'wallet-transfer': AppType.WALLET_TRANSFER,
    onboarding: AppType.MICRO_MERCHANT,
    authentication: AppType.AUTH,
  };

  return pathToAppModuleType[path] || AppType.DEPOSIT;
}
